import DisclaimerModal from "./DisclaimerModal";
import { useDisclaimer } from "../hooks/useDisclaimer";
import { applyAnalyticsConsent, trackEvent } from "../lib/analytics";

export default function DisclaimerGate() {
  const { loading, disclaimer, accepted, accept } = useDisclaimer();

  if (loading || !disclaimer) return null;
  const open = !accepted;

  return (
    <DisclaimerModal
      open={open}
      text={disclaimer.text}
      onAccept={async () => {
        await accept();

        // ✅ Consent aktivieren
        applyAnalyticsConsent(true);

        // ✅ Sofort Event feuern
        trackEvent("disclaimer_accepted", {
          version: disclaimer?.version ?? "unknown",
          debug_mode: true, // für DebugView in GA4
        });

        // ✅ Aktuellen Pageview nach Consent nachschieben
        import("../lib/analytics").then((m) => {
          m.trackPageview(window.location.pathname + window.location.search);
        });
      }}
    />
  );
}
